import React from "react";
import { useSelector } from "react-redux";
import { Alert, Button, Container } from "react-bootstrap";
import { RootState } from "../reducers";
import parse from "html-react-parser";
import { useNavigate } from "react-router-dom";

const Finished = () => {
  const messageFinish = useSelector(
    (state: RootState) => state.cart.messageFinish
  );
  const navigate: any = useNavigate()

  return (
    <Container>
      <div className="col-md-6">
        <h1 className="text-center">Recibido con exito!</h1>
        <p>Te enviamos un email con todos los detalles para que puedas hacer el seguimiento de tu pedido.</p>
        {messageFinish && (
          <Alert variant="success">{parse(messageFinish)}</Alert>
        )}

        <Button
          variant="secondary btn-lg mb-2"
          onClick={() => {
            navigate("/");
          }}
        >
          Inicio
        </Button>
      </div>
    </Container>
  );
};
export default Finished;
